import { useState, useEffect } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Services from "./component/Services";
import Refer_Upi from "./component/refer-upi/Refer_Upi";
import Bank_account_opening from "./component/refer-upi/Bank_account_opening";
import Demat_account from "./component/refer-upi/Demat_account";
import Small_loan from "./component/refer-upi/Small_loan";
import Personal_loan from "./component/refer-upi/Personal_loan";
import Credit_card from "./component/refer-upi/Credit_card";
import NotFound from "./pages/NotFound";
import UserDashboard from "./component/UserDashboard";
import ManageBankDetails from "./component/UserDashboard/BankDetails/ManageBankDetails";
import Referral from "./component/Referral";
import Share from "./component/Share";
import SettleToBank from "./component/UserDashboard/SettleToBank/SettleToBank";
import SharedReports from "./component/UserDashboard/Reports/Report";
import UserSettleReport from "./component/UserDashboard/SettlementReports/SettleReport";
import Grievance from "./component/UserDashboard/Complain/Grievance";
import Accordion from "./pages/Accordion";
import Home from "./component/UserDashboard/Home";
import ForgotPasswordForm from "./component/ForgotPassword/ForgotPasswordForm";
import ResetPasswordForm from "./component/ForgotPassword/ResetPasswordForm";
import ResetPasswordSent from "./component/ForgotPassword/ResetPasswordSent";

function App() {
  const location = useLocation();

  const shouldRenderNavbarAndFooter = ![
    "/userDash",
    "/userDash/reports",
    "/userDash/home",
    "/userDash/settletobank",
    "/userDash/complain",
    "/userDash/settlementreports",
    "/userDash/Small_loan",
    "/userDash/credit_card",
    "/userDash/refer",
    "/userDash/bank_account_opening",
    "/userDash/demat_account",
    "/userDash/small_loan",
    "/userDash/personal_loan",

  ].includes(location.pathname);

  return (
    <>
      <div className="App">
        <AuthProvider>
          {shouldRenderNavbarAndFooter && <Navbar />}
          <Routes>
            <Route path="/" element={<Services />} />
            <Route path="/refer-upi" element={<Refer_Upi />} />

            <Route path="/credit_card" element={<Credit_card />} />
            <Route
              path="/bank_account_opening"
              element={<Bank_account_opening />}
            />
            <Route path="/demat_account" element={<Demat_account />} />
            <Route path="/small_loan" element={<Small_loan />} />
            <Route path="/personal_loan" element={<Personal_loan />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
           
            <Route
              path="/userDash"
              element={<ProtectedRoutes component={UserDashboard} />}
            >
              <Route
                path="home"
                element={<ProtectedRoutes component={Home} />}
              />
              <Route
                path="manageBank"
                element={<ProtectedRoutes component={ManageBankDetails} />}
              />
              <Route
                path="settletobank"
                element={<ProtectedRoutes component={SettleToBank} />}
              />
              <Route
                path="reports"
                element={<ProtectedRoutes component={SharedReports} />}
              />
              <Route
                path="settlementreports"
                element={<ProtectedRoutes component={UserSettleReport} />}
              />
              <Route
                path="complain"
                element={<ProtectedRoutes component={Grievance} />}
              />
              <Route path="refer-upi" element={<Refer_Upi />} />
              <Route path="credit_card" element={<Credit_card />} />
              <Route
                path="bank_account_opening"
                element={<Bank_account_opening />}
              />
              <Route path="demat_account" element={<Demat_account />} />
              <Route path="small_loan" element={<Small_loan />} />
              <Route path="personal_loan" element={<Personal_loan />} />
            </Route>

            <Route path="/referral" element={<Referral />} />
            <Route path="/share" element={<Share />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/Accordion" element={<Accordion />} />
            <Route path = "/forgot-password" element={<ForgotPasswordForm/>}/>
            <Route path = "/reset-password" element={<ResetPasswordForm/>}/>
            <Route path = "/reset-password-sent" element={<ResetPasswordSent/>}/>
          </Routes>
          {shouldRenderNavbarAndFooter && <Footer />}
        </AuthProvider>
      </div>
    </>
  );
}

export default App;
